
import React from 'react'
import { ArrowRight } from 'lucide-react'

const services = [
  {
    title: 'Surface Express',
    description:
      'Cost-efficient surface freight solutions for smaller and larger shipments through reliable transportation, optimized routes, and coordinated delivery.',
    image: '/assets/services/ltl.png',
    link: '/services/surface-express'
  },
  {
    title: 'Full Truck Load (FTL)',
    description:
      'Dedicated vehicles for large, time-sensitive consignments, offering efficient transit, enhanced cargo handling, and reliable transportation.',
    image: '/assets/services/ftl.png',
    link: '/services/ftl'
  },
  {
    title: 'Third-Party Logistics (3PL)',
    description:
      'Integrated logistics services including transportation, warehousing, inventory management, and order fulfillment to support your supply chain.',
    image: '/assets/services/3pl.png',
    link: '/services/3pl'
  },
  {
    title: 'Express Delivery',
    description:
      'Priority shipping solutions for urgent shipments, designed to support time-sensitive deliveries with coordinated handling and shipment tracking.',
    image: '/assets/services/express-delivery.png',
    link: '/services/express-delivery'
  },
  {
    title: 'International Shipping',
    description:
      'International freight solutions with customs documentation support, shipment visibility, and coordination across air and sea transportation.',
    image: '/assets/services/international-shipping.png',
    link: '/services/international'
  },
  {
    title: 'Warehousing Solutions',
    description:
      'Organized warehousing with inventory management, efficient storage utilization, and flexible solutions to support your business requirements.',
    image: '/assets/services/warehousing.png',
    link: '/services/warehousing'
  }
]

export default function ServicesGridSection () {
  return (
    <section className='bg-white py-7 md:py-10 overflow-hidden'>
      <div className='max-w-7xl mx-auto px-5 md:px-8'>

        <div className='grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-12'>

          {/* LEFT CONTENT */}
          <div className='lg:col-span-1'>
            <div className='lg:sticky lg:top-28'>
              <span className='text-[#d32c30] text-xs font-extrabold uppercase tracking-[0.2em]'>
                What We Do
              </span>

              <h2 className='text-2xl sm:text-3xl font-extrabold leading-tight mt-4'>
                <span className='text-[#d32c30]'>
                  Smart Logistics
                </span>{' '}
                <span className='text-[#211f57]'>
                  by S Infinite
                </span>
              </h2>

              <div className='w-16 h-1.5 bg-[#d32c30] rounded-full mt-5' />

              <p className='text-gray-600 text-sm md:text-base leading-relaxed mt-6'>
                Moving businesses forward with reliable transportation,
                integrated logistics, and smart supply chain solutions.
              </p>

              <a
                href='/services'
                className='inline-flex items-center gap-2 mt-7 text-[#211f57] font-bold text-sm hover:text-[#d32c30] transition-colors'
              >
                Explore All Services
                <ArrowRight className='w-4 h-4' />
              </a>
            </div>
          </div>

          {/* RIGHT SERVICES GRID */}
          <div className='lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 md:gap-6'>
            {services.map((service, idx) => (
              <a
                key={idx}
                href={service.link}
                aria-label={`Explore ${service.title}`}
                className='group flex flex-col h-full bg-[#211f57] rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300'
              >
                {/* IMAGE */}
                <div className='relative h-48 md:h-52 overflow-hidden'>
                  <img
                    src={service.image}
                    alt={service.title}
                    loading='lazy'
                    className='w-full h-full object-cover transition-transform duration-700 group-hover:scale-110'
                  />

                  <div className='absolute inset-0 bg-gradient-to-t from-[#15143e]/90 via-black/20 to-transparent' />

                  <div className='absolute bottom-0 left-0 right-0 p-5'>
                    <h3 className='text-white text-lg font-extrabold leading-snug'>
                      {service.title}
                    </h3>

                    <div className='w-10 h-1 bg-[#fff44f] rounded-full mt-3 group-hover:w-16 transition-all duration-300' />
                  </div>
                </div>

                {/* CONTENT */}
                <div className='flex flex-col flex-1 p-5'>
                  <p className='text-sm text-gray-200 leading-relaxed flex-1'>
                    {service.description}
                  </p>

                  <div className='mt-6'>
                    <span className='inline-flex items-center justify-center gap-2 bg-[#d32c30] text-white text-xs font-extrabold px-4 py-2.5 rounded-lg group-hover:bg-[#fff44f] group-hover:text-[#211f57] transition-all duration-300'>
                      Know More
                      <ArrowRight className='w-4 h-4 group-hover:translate-x-1 transition-transform' />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

        </div>
      </div>
    </section>
  )
}
